


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, EMPTY } from 'rxjs';
import { tap, map, switchMap, take, catchError, withLatestFrom, filter, concatMap, mergeMap } from 'rxjs/operators';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { get, mergeWith } from 'lodash';

import { getValue } from '@app/shared/utils/feature-utils';
import * as fromStore from '@app/core/store';
import * as fromMaster from '../store/master-create-user.actions';
import { ActionHandler } from '@app/core/components/actions/action.handler';
import { MessagesService } from '@app/core/services/messages/message.service';
import { UserService } from '@services-api/user.service';
import { environment } from '@env/environment';
import { Client } from '@app/core/models/client.model';
const BASE_PATH = environment.basePath;

@Injectable()
export class MasterCreateUserEffects {
  constructor(
    private actions$: Actions,
    private actionHandler: ActionHandler,
    private store: Store<fromStore.State>,
    private message: MessagesService,
    private httpClient: HttpClient,
    private service: UserService,
  ) { }

  initValueService = (payload: any) => {
    const code = payload.code;
    if (typeof code === "undefined") {
      return this.service.createUserConfigGET()
        ;
    }
    if (payload.parentCtx && payload.parentCtx.roleName) {
      return this.store.select(fromStore.selectRoleValue, {
        ...payload.parentCtx,
        code
      });
    } else {

      return of({})
        ;
    }
  };

  initValue$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(fromMaster.initValueAction),
      switchMap(payload => {
        return this.initValueService(payload).pipe(
          map(
            result =>
              fromMaster.initValueSuccessAction({
                ...payload,

                result

              })
          ),
          catchError(error =>
            of(fromMaster.initValueFailAction({ ...payload, error }))
          )
        );
      }))
  );

  fetchddiPossibleValues$ = createEffect(() => this.actions$.pipe(
    ofType(fromMaster.fetchFieldPossibleValuesAction),
    filter(payload => payload.field === 'ddi'),
    switchMap(payload => {
      return this.service.listDDIs()

        .pipe(
          map(
            result =>
              fromMaster.fetchFieldPossibleValuesSuccessAction({
                ...payload,
                possibleValues: result,
                field: payload.field,
                separator: '|',
                keys: []
              })
          ),
          catchError(err =>
            of(fromMaster.fetchFieldPossibleValuesFailAction({}))
          )
        );
    })
  )
  );

  fetchclientsFantasyNamePossibleValues$ = createEffect(() => this.actions$.pipe(
    ofType(fromMaster.fetchFieldPossibleValuesAction),
    filter(payload => payload.field === 'clients.name'),
    switchMap(payload => {
      let filter = getValue(payload.data, 'clients', '');
      return this.service.listAllClients()
        .pipe(
          map(
            result =>
              fromMaster.fetchFieldPossibleValuesSuccessAction({
                ...payload,
                possibleValues: result,
                field: payload.field,
                separator: '|',
                keys: ['name']
              })
          ),
          catchError(err =>
            of(fromMaster.fetchFieldPossibleValuesFailAction({}))
          )
        );
    })
  )
  );


  getClientsFiltered(filter, result) {

    filter = filter.map((item) => item.name);

    var newResult: Client[] = [];

    newResult = result.filter(function (el) {

      let hasItem = false;
      filter.forEach(element => {
        if (element != null && element.name == el.name) {
          hasItem = true;
        }
      });
      console.log(hasItem);
      return !hasItem;
    });

    return newResult;
  }







}


